import { useCallback, useContext, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { CommonContext } from "./CommonContext";
import apiInterceptor from "services/apiInterceptor";
import { apiEndpoint } from "services/apiEndpoints";

export function useInterviewFeedback() {
  const { interview_id } = useParams();
  const queryParams = new URLSearchParams(window.location.search);
  const cid = queryParams.get("cid");
  const lastSentNote = useRef("");
  const {
    note,
    setNote,
    idRequestForNotes,
    userOwnData,
    feedbackGuid,
    setFeedbackGuid,
  } = useContext(CommonContext);

  const updateFeedbackHandler = useCallback(
    async (guid) => {
      const roundFeedbackGuid = guid || feedbackGuid;
      const data = {
        feedback: note,
        interviewGuid: interview_id,
        interviewerGuid: cid,
      };

      try {
        await apiInterceptor.put(
          `${apiEndpoint.interviewFeedback}/${roundFeedbackGuid}`,
          data
        );
      } catch (error) {
        console.error(error);
      }
    },
    [note, interview_id, cid, feedbackGuid]
  );

  useEffect(() => {
    if (!userOwnData.isCandidate) {
      const interval = setInterval(() => {
        if (note.trim() && note !== lastSentNote.current) {
          lastSentNote.current = note;
          const data = {
            feedback: note,
            interviewGuid: interview_id,
            interviewerGuid: cid,
          };

          if (idRequestForNotes.current) {
            idRequestForNotes.current = true;
            updateFeedbackHandler();
          } else {
            const jsonData = JSON.stringify(data);

            const formData = new FormData();
            formData.append(
              "interviewFeedbackFilter",
              new Blob([jsonData], { type: "application/json" })
            );
            const config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            };

            idRequestForNotes.current = true;
            apiInterceptor
              .post(apiEndpoint.interviewFeedback, formData, config)
              .then((response) => {
                if (response.data.status === "ERROR") {
                  setFeedbackGuid(response.data.statusGUID);
                  updateFeedbackHandler(response.data.statusGUID);
                } else {
                  setFeedbackGuid(response.data.data);
                }
              })
              .catch((error) => {
                console.error(error);
              });
          }
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [
    note,
    interview_id,
    cid,
    updateFeedbackHandler,
    setFeedbackGuid,
    idRequestForNotes,
    userOwnData.isCandidate,
  ]);

  return {
    note,
    setNote,
    feedbackGuid,
    setFeedbackGuid,
    updateFeedbackHandler,
  };
}
